import { render, staticRenderFns } from "./DocumentListProvider.vue?vue&type=template&id=2e739d22&scoped=true&"
import script from "./DocumentListProvider.vue?vue&type=script&lang=ts&"
export * from "./DocumentListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e739d22",
  null
  
)

export default component.exports